import React from "react";
import styled from "styled-components";
import { withTranslation, WithTranslation } from "react-i18next";
import { Element } from "react-scroll";

import { H2, H2Pre, Body1Pre, Button } from "src/components/Typography";
import { colors } from "src/styles/colors";
import images from "src/images";
import { translate } from "src/locales";
import { media } from "src/utils/media";
import { gTagEvent, ActionType, CategoryType } from "src/configs/analytics";
import TypeformButton from "src/components/TypeformButton";
import { getLinksByLanguage } from "src/constants/link";

type Props = WithTranslation;

const Container = styled.div`
  display: flex;
  background-color: ${colors.bg.white.main};
  min-width: 1440px;
  height: 880px;
  padding-top: 200px;
  padding-bottom: 200px;
  ${media.mobile`
    min-width: auto;
    height: auto;
    padding-top: 108px;
    padding-bottom: 0px;
  `}
`;

const Inner = styled.div`
  display: flex;
  flex-direction: row;
  width: 1268px;
  margin: auto;
  ${media.mobile`
    flex-direction: column-reverse;
    width: 100%;
    overflow: hidden;
  `}
`;

const LeftGroup = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 640px;
  height: 480px;
  ${media.mobile`
    min-width: auto;
    height: auto;
  `}
`;

const GasFeesBgImage = styled.img`
  position: absolute;
  left: -20px;
  width: 661px;
  height: 480px;
  display: flex;
  ${media.mobile`
    position: static;
    width: 100%;
    height: auto;
  `}
`;

const RightGroup = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 141px;
  ${media.mobile`
    align-items: center;
    padding-left: 0px;
  `}
`;

const InnerRightGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 540px;
  ${media.mobile`
    align-items: center;
    min-width: 100%;
    padding-left: 24px;
    padding-right: 24px;
    margin-right: 0px;
  `}
`;

const Title = styled(H2Pre)`
  color: ${colors.text.dark.title};
  ${media.mobile`
    text-align: center;
    margin-top: 0px;
  `}
`;

const Description = styled(Body1Pre)`
  color: ${colors.text.dark.body};
  margin-top: 23px;
  ${media.mobile`
    max-width: 327px;
    margin-top: 20px;
    text-align: center;
    white-space: normal;
  `}
`;

const Link = styled(TypeformButton)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.primary.default};
  white-space: nowrap;
  &:hover {
    color: ${colors.primary.hover};
  }
  margin-top: 68px;
  cursor: pointer;
  ${media.mobile`
    margin-top: 32px;
    margin-bottom: 72px;
  `}
`;

const LinkIcon = styled.img`
  height: 12px;
  margin-left: 8.5px;
`;

const SaveGasFeesSection = (props: Props) => {
  const { t, i18n } = props;
  const isKo = i18n.language === "ko";
  const language = i18n.language;

  const onLink = () => {
    // TODO EVENT
  };

  return (
    <Container>
      <Inner>
        <LeftGroup>
          <GasFeesBgImage
            src={isKo ? images.gasFeesBgSrc : images.gasFeesEnBgSrc}
          />
        </LeftGroup>
        <RightGroup>
          <InnerRightGroup>
            <Title>{translate(["saveGasFeesSection", "title"], t)}</Title>
            <Description>
              {translate(["saveGasFeesSection", "description"], t)}
            </Description>
            <Link
              typeformUri={getLinksByLanguage(language).home.saveGasFeesSection}
              onClick={onLink}
            >
              {translate(["saveGasFeesSection", "registerButton"], t)}
              <LinkIcon src={images.arrowRightSrc} srcSet={images.arrowRight} />
            </Link>
          </InnerRightGroup>
        </RightGroup>
      </Inner>
    </Container>
  );
};

export default withTranslation()(SaveGasFeesSection);
